var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "both-pd-box1",
      staticStyle: {
        background: "#fff",
        "min-height": "94vh",
        "padding-bottom": "40px",
      },
    },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "推送消息创建", name: "first" } },
            [_vm.activeName === "first" ? _c("PushMessageCreation") : _vm._e()],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "创建记录", name: "second" } },
            [_vm.activeName === "second" ? _c("CreateARecord") : _vm._e()],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }